import React from 'react';
import { Tooltip } from '@fx-ui/fine-design';
import { IconFont } from '~/components';
import Intl from '@fx-ui/intl';
import { useStores } from '~/hooks';

const Browser: React.FC = () => {
    const { jsSdkStore } = useStores();
    return (
        <Tooltip content={Intl.get('openBrowser')} effect="dark" placement="bottom">
            <div
                className="fx-nav-browser"
                onClick={() => {
                    return jsSdkStore.openClientLinkWithSSO(window.location.href);
                }}
            >
                <IconFont type="browser" />
            </div>
        </Tooltip>
    );
};

export default Browser;
